import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { UploadContentComponent } from './upload-content/upload-content.component';
import { ContentHistoryComponent } from './content-history/content-history.component';

@Component({
  selector: 'app-content-management',
  templateUrl: './content-management.component.html',
  styleUrls: ['./content-management.component.scss'],
  imports: [MatTabsModule, UploadContentComponent, ContentHistoryComponent],
})
export class ContentManagementComponent {
  viewItem = null;

  onViewCopy(ev) {
    this.viewItem = { ...ev };
  }
}
